import { Component, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiLanguagesService } from '../../../../../services/languages/api/api-languages.service';
import { AlertsService } from '../../../../../services/alerts.service';

@Component({
  selector: 'app-language-translation-add-modal',
  templateUrl: './language-translation-add-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class LanguageTranslationAddModalComponent {

  @Input() languageId: number = 0;

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  translationKey: string = '';
  translationValue: string = '';

  private callbackSaved?: () => void;

  constructor(private apiLanguagesService: ApiLanguagesService, private alertsService: AlertsService) {}

  show(callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.translationKey = '';
    this.translationValue = '';
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    this.apiLanguagesService.addLanguageTranslation(this.languageId, this.translationKey, this.translationValue).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Translation added !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error adding translation : ' + error);
      }
    );
  }
}
